define("shared/components/shared/wizards/carousel/step-one", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="tOB--wizard">
    {{! Image }}
    <div class="tOB--wizard__left">
      <img class="o--media" src="/assets/images/img--multiPost--slide2.png" />
    </div>
    {{! Description }}
    <div class="tOB--wizard__right">
      <h3 class="tOB--wizard__title">
        {{t "tutorials.multi_image.slide_1.title"}}
      </h3>
      <p class="tOB--wizard__subtitle">
        {{t "tutorials.multi_image.slide_1.info" count=this.stepsCount}}
      </p>
      <ul class="tOB--wizard__ul">
        <li class="tOB--wizard__li">
          <span class="tOB--wizard__step">
            {{t "wizards.shared.step_1"}}
          </span>
          <span class="u--text--bold">
            {{t "tutorials.multi_image.slide_1.point_1_heading"}}
          </span>
          <p>
            {{t "tutorials.multi_image.slide_1.point_1_text"}}
          </p>
        </li>
        <li class="tOB--wizard__li">
          <span class="tOB--wizard__step">
            {{t "wizards.shared.step_2"}}
          </span>
          <span class="u--text--bold">
            {{t "tutorials.multi_image.slide_1.point_2_heading"}}
          </span>
          <p>
            {{t "tutorials.multi_image.slide_1.point_2_text"}}
          </p>
        </li>
        {{#if @canAutoPublish}}
          <li class="tOB--wizard__li">
            <span class="tOB--wizard__step">
              {{t "wizards.shared.step_3"}}
            </span>
            <span class="u--text--bold">
              {{t "tutorials.multi_image.slide_1.point_3_heading"}}
            </span>
            <p>
              {{t "tutorials.multi_image.slide_1.point_3_text"}}
            </p>
          </li>
        {{/if}}
      </ul>
    </div>
  </section>
  */
  {
    "id": "s/83suVp",
    "block": "[[[10,\"section\"],[14,0,\"tOB--wizard\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tOB--wizard__left\"],[12],[1,\"\\n    \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--multiPost--slide2.png\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tOB--wizard__right\"],[12],[1,\"\\n    \"],[10,\"h3\"],[14,0,\"tOB--wizard__title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_1.title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"tOB--wizard__subtitle\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_1.info\"],[[\"count\"],[[30,0,[\"stepsCount\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"ul\"],[14,0,\"tOB--wizard__ul\"],[12],[1,\"\\n      \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tOB--wizard__step\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"wizards.shared.step_1\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_1.point_1_heading\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_1.point_1_text\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tOB--wizard__step\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"wizards.shared.step_2\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_1.point_2_heading\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_1.point_2_text\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,1],[[[1,\"        \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"tOB--wizard__step\"],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"wizards.shared.step_3\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_1.point_3_heading\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_1.point_3_text\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@canAutoPublish\"],false,[\"t\",\"if\"]]",
    "moduleName": "shared/components/shared/wizards/carousel/step-one.hbs",
    "isStrictMode": false
  });
  class StepOneComponent extends _component2.default {
    get stepsCount() {
      return this.args.canAutoPublish ? '3' : '2';
    }
  }
  _exports.default = StepOneComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, StepOneComponent);
});